// extracted by mini-css-extract-plugin
export default {"button":"Button_button__Zk130","content":"Button_content__iejov","icon":"Button_icon__A69vU","left":"Button_left__3VVjt","right":"Button_right__i+n72","text":"Button_text__hSk4A"};